//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { LocalizationHelper, TypeHelper } from '../../helpers'

//#region Public Types

export const SELECT_BOX_CONTROLS_SERVICE_NAME = 'SelectBoxControlsService'
export const SELECT_BOX_CONTROLS_SERVICE_PROVIDER_NAME = 'SelectBoxControlsServiceProvider'

export interface GetSelectBoxOptions {
    items: any[]
}

//#endregion


export class SelectBoxControlsService {

    //#region Select Box

    public getSelectBoxOptions(options?: GetSelectBoxOptions): DevExpress.ui.dxSelectBoxOptions {
        return this.getCommonSelectTagBoxOptions(options) as DevExpress.ui.dxSelectBoxOptions
    }

    //#endregion


    //#region Common

    private getCommonSelectTagBoxOptions(options?: GetSelectBoxOptions): DevExpress.ui.dxTagBoxOptions | DevExpress.ui.dxSelectBoxOptions {
        const tagBoxOptions: DevExpress.ui.dxTagBoxOptions | DevExpress.ui.dxSelectBoxOptions = {
            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
        }

        if (options != null) {
            const firstItem = _.first(options.items)

            if (firstItem != null) {
                if (TypeHelper.isIReferenceType(firstItem)) {
                    tagBoxOptions.displayExpr = 'toString'
                    tagBoxOptions.valueExpr = 'getReferenceKey'
                }
                else if (TypeHelper.isIOpObject(firstItem)) {
                    tagBoxOptions.displayExpr = 'toString'
                    tagBoxOptions.valueExpr = 'idObject'
                }
            }

            tagBoxOptions.items = options.items || []
        }

        return tagBoxOptions
    }

    //#endregion

}

export class SelectBoxControlsServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [function () {
        return new SelectBoxControlsService()
    }]

    //#endregion
} 